$(function() {
   $(".hamburger").click(function() {
       $(this).toggleClass("active");
       var nav = $(".header__nav");
       $(this).hasClass("active")?nav.addClass("active"):nav.removeClass("active");
   });
});